import React, { useState } from "react";
import { Divider, Layout } from "antd";

import MenuApp from "components/menu-app";
import { setLogoutUser } from "reducer/login/login-user";
import { useDispatch } from "react-redux";
import Header from "./header";
import { USER_STORAGE, ACCESS_TOKEN, BRANCH_STORAGE } from "constants/index";
import { useNavigate } from "react-router-dom";
import useBreakpoint from "hooks/useBreakpoint";

const { Content } = Layout;

const MainApp = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isDesktop } = useBreakpoint();
  const useMobileMenu = !isDesktop;
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  function logout() {
    localStorage.removeItem(ACCESS_TOKEN);
    localStorage.removeItem(USER_STORAGE);
    localStorage.removeItem(BRANCH_STORAGE);
    dispatch(setLogoutUser());
    navigate("/login");
  }

  return (
    <Layout className="app-shell">
      {!useMobileMenu && (
        <MenuApp
          isMobile={false}
          mobileMenuOpen={false}
          onMobileMenuClose={() => {}}
        />
      )}

      <Layout style={{ padding: 0, flex: 1, minWidth: 0, background: "#E0E2E7" }}>
        <Header
          logout={logout}
          isMobile={useMobileMenu}
          onMenuToggle={() => setMobileMenuOpen(true)}
        />
        <Divider style={{ margin: "0px", background: "#E0E0E0" }} />

        <Content className="app-shell-content">{props.component}</Content>
      </Layout>

      {useMobileMenu && (
        <MenuApp
          isMobile
          mobileMenuOpen={mobileMenuOpen}
          onMobileMenuClose={() => setMobileMenuOpen(false)}
        />
      )}
    </Layout>
  );
};

export default MainApp;
